import Resource from './base.resource'

export default class GlazesResource extends Resource
{
    constructor() {
        super('glazes')
    }
}
